import { fetchHoliday, HolidayEventQueryParams } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useHolidayEvents(params: HolidayEventQueryParams) {
  const { server } = useServer()

  return useQuery({
    queryKey: keys.list(params),
    queryFn: fetch,
  })

  function fetch() {
    return fetchHoliday(server, params)
  }
}
